/**
 * W76.3 — Crypto Fear-and-Greed-Index (alternative.me).
 *
 * Free-API: https://api.alternative.me/fng/?limit=1
 * Update-Frequenz: 1× pro Tag (00:00 UTC). Wert 0-100.
 *   0-25  = Extreme Fear (Bullish-Contrarian)
 *   25-50 = Fear
 *   50-75 = Greed
 *   75-100= Extreme Greed (Bearish-Contrarian)
 *
 * Audit Agent F HIGH: war Top-1-Datenquelle fuer Krypto. Wird als Hero-Metric
 * auf Watchlist-Krypto-Tab + Symbol-Detail angezeigt.
 *
 * Hinweis: Frontend-fetch (kein Server-Cron). Caching via useDataState 30 Min
 * — bei alternative.me Update 1×/Tag mehr als ausreichend.
 */

export interface FearGreedSnapshot {
  /** Wert 0-100 */
  value: number;
  /** Label aus API (z.B. "Extreme Greed") */
  value_classification: string;
  /** ISO-Timestamp der API-Update */
  timestamp_utc: string;
  /** Klartext-Phase (DE) */
  phase_de: string;
  /** Trade-Hinweis (Contrarian-Signal) */
  hint_de: string;
}

interface AlternativeMeResponse {
  data: Array<{
    value: string;
    value_classification: string;
    timestamp: string;
    time_until_update?: string;
  }>;
}

function classifyDe(value: number): { phase: string; hint: string } {
  if (value <= 20) {
    return {
      phase: 'Extreme Angst',
      hint: 'Klassischer Contrarian-Bottom-Indikator — historisch oft Akkumulationszone',
    };
  }
  if (value <= 40) {
    return { phase: 'Angst', hint: 'Risk-Off-Phase — selektiv kaufen' };
  }
  if (value <= 55) {
    return { phase: 'Neutral', hint: 'Mittelfeld — Trend dominiert' };
  }
  if (value <= 75) {
    return { phase: 'Gier', hint: 'Risk-On — aber Profit-Mitnahme einplanen' };
  }
  return {
    phase: 'Extreme Gier',
    hint: 'Contrarian-Top-Indikator — Stops eng halten, neue Long-Trades vermeiden',
  };
}

export async function fetchFearGreedIndex(
  signal?: AbortSignal
): Promise<FearGreedSnapshot | null> {
  try {
    const res = await fetch('https://api.alternative.me/fng/?limit=1', {
      signal,
    });
    if (!res.ok) return null;
    const json = (await res.json()) as AlternativeMeResponse;
    const row = json.data[0];
    if (!row) return null;
    const value = Number(row.value);
    if (!Number.isFinite(value)) return null;
    const { phase, hint } = classifyDe(value);
    return {
      value,
      value_classification: row.value_classification,
      timestamp_utc: new Date(Number(row.timestamp) * 1000).toISOString(),
      phase_de: phase,
      hint_de: hint,
    };
  } catch {
    return null;
  }
}
